export default __webpack_public_path__ + "static/media/O3.86265e72.jpg";